import React, { useRef, useEffect, lazy, Suspense } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import classes from "../css/lisitng.module.scss";
import Item from "./item";
import {
  addToCart,
  addToWishlist,
  removeFromWishlist,
  addToCompare,
  removeFromCompare,
} from "../../../actions";
import Pagination from "./Pagination";
import ProductShimmer from "./ProductShimmer";

const AppliedFilterTags = lazy(() => import("./filter/AppliedFilterTags"));

const EmptyViewIllustration = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 140 140"
    fill="none"
    role="img"
    aria-label="No products illustration"
  >
    <defs>
      <linearGradient id="emptyBg" x1="20" y1="16" x2="122" y2="124" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FDF2F8" />
        <stop offset="1" stopColor="#F3F4F6" />
      </linearGradient>
      <linearGradient id="lensRing" x1="52" y1="36" x2="93" y2="80" gradientUnits="userSpaceOnUse">
        <stop stopColor="#722257" />
        <stop offset="1" stopColor="#A8557A" />
      </linearGradient>
    </defs>

    <rect x="8" y="8" width="124" height="124" rx="24" fill="url(#emptyBg)" />

    <path
      d="M38 102C41.5 91 51 84 62.5 84H71C83 84 92.5 91 96 102"
      stroke="#E5E7EB"
      strokeWidth="2.5"
      strokeLinecap="round"
    />

    <circle cx="61" cy="59" r="22" stroke="url(#lensRing)" strokeWidth="4" />
    <circle cx="61" cy="59" r="14" stroke="#E9D5E0" strokeWidth="2.5" />
    <path d="M76.5 74.5L95 93" stroke="#722257" strokeWidth="5" strokeLinecap="round" />

    <path d="M53 53H69" stroke="#D1D5DB" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M53 60H64" stroke="#E5E7EB" strokeWidth="2.5" strokeLinecap="round" />

    <circle cx="101" cy="34" r="9" fill="#FFFFFF" stroke="#F0D9E6" />
    <path d="M101 30V38" stroke="#722257" strokeWidth="2" strokeLinecap="round" />
    <path d="M97 34H105" stroke="#722257" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const ListingPanel = (props) => {
  const {
    products,
    symbol,
    addToCart,
    addToWishlist,
    removeFromWishlist,
    addToCompare,
    removeFromCompare,
    wishListItems,
    compareItems,
    selectedPage,
    selectedSorting,
    setSelectedSorting,
    totalProducts,
    hitsPerPage,
    handlePageChange,
    loadNextPage,
    isMobile,
    totalPages,
    productShimmer,
    variantTag,
    isFetching,
    selectedFilters,
    setSelectedFilters,
    selectedRangeFilters,
    setSelectedRangeFilters,
    rangeQuery,
    resetFilters,
  } = props;

  const sentinelRef = useRef(null);
  const defaultSortMatch = window.filterOption.algolia_sorting.find(
    (option) => option.name === "Name: A to Z"
  );
  const defaultSortValue = defaultSortMatch ? defaultSortMatch.value : window.rc.algoliasearch.defaultIndex;
  const sortControlValue = selectedSorting || defaultSortValue;
  const isEmptySort =
    sortControlValue && sortControlValue.replace("products_list", "");
  const selectedSortMatch =
    isEmptySort &&
    window.filterOption.algolia_sorting.find(
      (item) => item.value === sortControlValue,
    );
  const selectedSortLabel =
    isEmptySort && selectedSortMatch ? selectedSortMatch.name : "Sort By";

  // IntersectionObserver for infinite scroll on mobile
  useEffect(() => {
    if (!isMobile || !loadNextPage) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (
          entry.isIntersecting &&
          selectedPage < totalPages - 1 &&
          !isFetching
        ) {
          loadNextPage();
        }
      },
      { threshold: 0.1 },
    );

    if (sentinelRef.current) {
      observer.observe(sentinelRef.current);
    }

    return () => {
      if (sentinelRef.current) {
        observer.unobserve(sentinelRef.current);
      }
    };
  }, [isMobile, loadNextPage, selectedPage, totalPages, isFetching]);

  return (
    <div>
      {/* <CategoryDescription
        categoryTitle={props.title}
        categoryDescription={props.description}
        selectedSorting={selectedSorting}
        setSelectedSorting={setSelectedSorting}
        totalProducts={totalProducts}
        history={props.history}
        productsCount={products.length}
      /> */}

      <Suspense fallback={null}>
        <div className={classes.listing_header}>
          <AppliedFilterTags
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            selectedRangeFilters={selectedRangeFilters}
            setSelectedRangeFilters={setSelectedRangeFilters}
            rangeQuery={rangeQuery}
            resetFilters={resetFilters}
          />
          {/* <p className=" text-muted text-small">
              {products.length} / {totalProducts} Products
            </p> */}
          <div
            className={`${classes.sorting} d-none ${totalProducts > 0 ? "d-xl-flex" : ""
              }`}
          >
            <p className={classes.product_count}>{totalProducts} Products</p>
            <button className={`${classes.sorting_button} `} type="button">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 7.5H22"
                  stroke="black"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
                <path
                  d="M6 11.5H18"
                  stroke="black"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 15.5H15"
                  stroke="black"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
              </svg>

              {selectedSortLabel}
            </button>
            <div
              className={classes.deopdown}
              data-uk-dropdown="mode: click; pos: bottom-center; target: !.uk-button-group;"
            >
              <ul className="uk-nav uk-dropdown-nav">
                {window.filterOption.algolia_sorting.map((element, i) => (
                  <li
                    key={i}
                    className="d-block uk-dropdown-close"
                    onClick={() => setSelectedSorting(element.value)}
                  >
                    <a role="button" tabIndex={0}>{element.name}</a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </Suspense>
      {productShimmer ? (
        <ProductShimmer />
      ) : products !== undefined && products.length > 0 ? (
        <div>
          <div className={classes.product_list}>
            {products.map((product, index) => (
              <Item
                key={index}
                index={index}
                product={product}
                productId={product.objectID}
                symbol={symbol}
                onAddToCompareClicked={addToCompare}
                onRemoveFromCompareClicked={removeFromCompare}
                onAddToWishlistClicked={addToWishlist}
                onRemoveFromWishlistClicked={removeFromWishlist}
                onAddToCartClicked={addToCart}
                variantTag={variantTag}
                wishListedItem={wishListItems}
                compareItems={compareItems}
              />
            ))}
          </div>
          {/* Pagination for desktop, Infinite scroll sentinel for mobile */}
          {totalProducts > hitsPerPage && (
            <>
              {!isMobile ? (
                <Pagination
                  selectedPage={selectedPage}
                  totalPages={totalPages}
                  handlePageChange={handlePageChange}
                />
              ) : (
                <div
                  ref={sentinelRef}
                  className="uk-width-1-1 uk-text-center uk-padding"
                  style={{ minHeight: "50px" }}
                >
                  {isFetching && <div data-uk-spinner></div>}
                </div>
              )}
            </>
          )}
          <div className="text-muted uk-hidden@s w-100 uk-text-center mt-5">
            Showing {products.length} in {totalProducts} Products
          </div>
        </div>
      ) : (
        <div className={classes.empty_state}>
          <div className={classes.empty_icon}>
            <EmptyViewIllustration />
          </div>
          <h3 className={classes.empty_title}>No Products Found</h3>
          <p className={classes.empty_text}>
            We couldn't find what you're looking for. Try exploring our popular
            categories below.
          </p>
          <div className={classes.empty_categories}>
            {((window.homeshopbycategory && window.homeshopbycategory.images) || []).slice(0, 4).map((item, index) => (
              <Link
                key={index}
                to={`${process.env.PUBLIC_URL}/${item.link}`}
                className={classes.empty_cat}
              >
                <img
                  src={item.pictures}
                  alt={item.title}
                />
                <span>{item.title}</span>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  symbol: state.data.symbol,
  wishListItems: state.wishlist.list,
  compareItems: state.compare.items,
});

export default connect(mapStateToProps, {
  addToCart,
  addToWishlist,
  removeFromWishlist,
  addToCompare,
  removeFromCompare,
})(ListingPanel);
